import { z } from "zod/v4";
import { common } from "../common";

/**
 * Schema for multi-language composition setup.
 * This is embedded in message variations to track locales and translations.
 *
 * @see Braze::Communication::MultiLanguageSupport::CompositionSetup
 */
export const multiLanguageCompositionSetupSchema = z.object({
  locale_ids: z.array(common.objectId),
  translation_in_use_ids: z.array(common.objectId),
});
